export function eachOfInterval(start: number, end: number, period: number, safeNumber?: number) {
  const ans = [];
  for (let i = start; i <= end; i += period) {
    if (safeNumber) {
      ans.push(Math.round(i * safeNumber) / safeNumber);
    } else {
      ans.push(i);
    }
  }
  return ans;
}

export function parseTimeZoneToHours(timeZone: string): number {
  const cleaned = timeZone.trim().replace(/^\+/, '');

  const isNegative = cleaned.startsWith('-');
  const withoutSign = isNegative ? cleaned.substring(1) : cleaned;

  const parts = withoutSign.split(':');
  const hours = parseInt(parts[0] || '0', 10);
  const minutes = parts[1] ? parseInt(parts[1], 10) : 0;

  const totalHours = hours + minutes / 60;

  return isNegative ? -totalHours : totalHours;
}

export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

export function isObjectEmpty(obj: Record<string, unknown>): boolean {
  return Object.keys(obj).length === 0;
}

export function convertDepthUnitValue(value: number, currentUnit: 'm' | 'ft', targetUnit: 'm' | 'ft'): number {
  if (currentUnit === targetUnit) {
    return Math.round(value * 100) / 100;
  }

  const factor = currentUnit === 'm' ? 3.28084 : 1 / 3.28084;
  const convertedValue = value * factor;

  return convertedValue;
}

type QueryParamsPrimitive = string | number | boolean | null | undefined | Date;
type QueryParams = Record<string, QueryParamsPrimitive | QueryParamsPrimitive[]>;

export const serializeQueryParamsRepeatNoEncode = (params: QueryParams): string => {
  const parts: string[] = [];

  const push = (key: string, value: QueryParamsPrimitive) => {
    if (value === undefined || value === null) return;
    if (value instanceof Date) {
      parts.push(`${key}=${value.toISOString()}`);
      return;
    }
    parts.push(`${key}=${String(value)}`);
  };

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const item of value) push(key, item);
      continue;
    }
    push(key, value);
  }

  return parts.join('&');
};

export function waitPromise(delay: number) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export function roundNumber(
  value: number | string,
  fraction: number = 0,
  method: 'floor' | 'ceil' | 'round' = 'floor',
): number {
  const valueNumber = Number.parseFloat(value.toString());

  if (Number.isNaN(valueNumber)) {
    return valueNumber;
  }

  if (fraction === 0) {
    return Math[method](valueNumber);
  }

  const denominator = 10 ** fraction;

  return Math[method](valueNumber * denominator) / denominator;
}

export function arraysEqual<T>(a: Array<T>, b: Array<T>) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  return a.every((item) => b.includes(item));
}
export function arraySum(array: number[]): number {
  return array.reduce((acc, curr) => acc + curr, 0);
}

export function hasValue<T>(value: T | null | undefined): value is T {
  if (Array.isArray(value)) {
    return value.length !== 0;
  }
  return value !== null && value !== undefined;
}
